import { makeAutoObservable } from 'mobx';
import { validateAtrTrail } from './validateAtrTrail';

export class AtrTrailData {
  pctOfAtr = 300;
  ATR = {
    candlesBack: 14, //field # of candles
    atrType: 'WILDER', //options: SMA, WILDER, SMA_NO_GAP. drop down. wilder used 90% of time
    candleDuration: 1, //do candle duration + time unit combo
    timeUnit: 'MINUTES',
  };

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach((field) => {
        if (field === 'pctOfAtr') {
          this.pctOfAtr = Number(initialData.pctOfAtr) * 100;
        } else {
          this[field] = initialData[field];
        }
      });
    }
  }
  //common methods
  resetToDefaults = () => {
    this.pctOfAtr = 1;
    this.ATR = {
      candlesBack: 14, //field # of candles
      atrType: 'WILDER', //options: SMA, WILDER, SMA_NO_GAP. drop down. wilder used 90% of time
      candleDuration: 1, //do candle duration + time unit combo
      timeUnit: 'MINUTES',
    };
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const result = validateAtrTrail(this.pctOfAtr, this.ATR);
    return result;
  };
  returnJson = () => {
    return {
      pctOfAtr: Number(this.pctOfAtr) / 100,
      ATR: this.ATR,
    };
  };
  //specific methods

  //setters
  setPctOfAtr = (number) => {
    this.pctOfAtr = number;
  };
  setCandlesBack = (number) => {
    this.ATR.candlesBack = number;
  };
  setAtrType = (string) => {
    this.ATR.atrType = string;
  };
  setCandleDuration = (number) => {
    this.ATR.candleDuration = number;
  };
  setTimeUnit = (string) => {
    this.ATR.timeUnit = string;
  };
}
